<template>
    <div :class="`col xs-8 sm-8 md-4 lg-4 xl-4 tile relative ${selectedClass}`" @click="paymentTileSelected">
        <div v-if="showTileDealMessaging" class="absolute top-0 left-0" :class="this.isPhoenixPhaseThreeCustomer && SFDCPaymentTypeToVariableName[paymentPlan] === 'monthly'  ? 'messaging light-tile-banner' : 'messaging'"> {{ tileDealMessaging }}</div>
        <div class="tile-info">
            <div>
                <h4 class="header-styling" :class="headerStyling">{{ paymentHeader }}</h4>
                <div v-if="paymentSubHeader" class="sub-header-styling mb-1 bold text-xl">{{ paymentSubHeader }}</div>
                <div :class="this.isPhoenixPhaseThreeCustomer ? 'monthly-cost !mb-0' : 'monthly-cost'">{{ monthlyCost }}</div>
                <div v-if="showTileDealMessaging" class="list-price-styling line-through text-gray-500">{{  `${currencySymbol}${monthlyListPriceCost.toFixed(2)}/${renewalsPersistedVariables.jsonContent.text.month}` }}</div>
                <div class="total-savings" v-if="isPhoenixPhaseTwoCustomer && totalSavings">Save {{totalSavings}} in total</div> 
                <div v-if="!isPhoenixPhaseThreeCustomer" v-html="breakdown"></div>
                <div class="save bold" v-if="discount">{{ discount }}</div>
                <div v-if="phoenixExptChanges" class="flex justify-center mt-1 total-payments text-center">
                    {{ totalMessaging }} 
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { SFDCPaymentTypeToVariableName } from '../../../../corpweb_globals'
import formatCurrency from '../webstore/mixins/formatCurrency';
import { analyticsTrack } from '../../../plugins/segment';
import RenewalsResources from '../../../mixins/renewals-resources';
export default {
    mixins: [formatCurrency, RenewalsResources],
    props: {
        paymentPlan: {
            type: String,
            required: true
        },
        paymentHeader: {
            type: String,
            required: true
        },
        paymentSubHeader: {
            type: String,
            required: false,
            default: null
        },
        monthlyCost: {
            type: String,
            required: true
        },
        breakdown: {
            type: String,
            required: true
        },
        discount: {
            type: String,
            required: false
        },
        totalSavings: {
            type: String,
            required: false,
            default: null
        },
        monthlyListPriceCost: {
            type: Number,
            required: true
        }
    },
    data(){
        return {
            paymentFrequency: {
                'Direct Annual' : 'annually',
                'Direct Monthly' : 'monthly', 
                'Upfront Payments' : 'upfront'
            }
        }
    },
    computed: {
        ...mapGetters(['isPhoenixPhaseTwoCustomer', 'isPhoenixPhaseThreeCustomer', 'applicationVersion', 'typeOfRenewal', 'productSource']),
        ...mapGetters('content', [
            'checkoutContent',
            'renewalsPersistedVariables'
        ]),
        ...mapGetters('checkout', [
            'accountId',
            'opptyId',
            'selectedPaymentType',
            'licenseTerm',
            'renewalTerm',
            'writtenLanguage'
        ]),
        ...mapGetters('shoppingCart', [
            'productCostsInfo',
            'renewalDiscountMatrix'
        ]),
        selectedClass() {
            return this.paymentPlan === this.selectedPaymentType ? 'selected' : '';
        },
        tileDealMessaging(){
            if (this.isPhoenixPhaseTwoCustomer) {
                if (SFDCPaymentTypeToVariableName[this.paymentPlan] === 'annual') {
                    return 'Most Popular!'
                } else if( SFDCPaymentTypeToVariableName[this.paymentPlan] === 'upfront') {
                    return 'Best Deal!'
                }
            } else if (this.isPhoenixPhaseThreeCustomer) {
                return `${this.renewalsPersistedVariables.jsonContent.text.save} ${Math.round(this.renewalDiscountMatrix[this.paymentPlan])}%`
            }
        },
        showTileDealMessaging(){
            if (this.isPhoenixPhaseThreeCustomer) {
                return this.renewalDiscountMatrix[this.paymentPlan] !== 0
            }
            return this.isPhoenixPhaseTwoCustomer && SFDCPaymentTypeToVariableName[this.paymentPlan] !== 'monthly' && this.renewalTerm === 36;
        },
        SFDCPaymentTypeToVariableName(){
            return SFDCPaymentTypeToVariableName;
        },
        headerStyling() {
            let headerStyling = `${this.phoenixExptChanges && this.showTileDealMessaging ? "mb-0 bold pt-2" : "mb-0 bold"}${this.writtenLanguage !== "English" ? " min-h-[114px]" : ""}`;
            return headerStyling;
        },
        totalMessaging() {
            let paymentFrequency = this.paymentFrequency[this.paymentPlan];
            let capitalizedPaymentFrequency = paymentFrequency.charAt(0).toUpperCase() + paymentFrequency.slice(1);
            let messaging = `${this.formatNumberToCurrency(this.productCostsInfo.order_subtotals[SFDCPaymentTypeToVariableName[this.paymentPlan]])} ${this.renewalsPersistedVariables.jsonContent.text[`due${capitalizedPaymentFrequency}`]}` ;
            if (this.isPhoenixPhaseThreeCustomer) {
                return messaging + this.renewalsPersistedVariables.jsonContent.text.plusTax;
            }
            return messaging;
        }
    },
    methods: {
        ...mapMutations('checkout', [
            'setSelectedPaymentType',
        ]),

        setSelectedPaymentTypeHandler(plan) {
            this.setSelectedPaymentType(plan);
            this.$emit("scrollToPricingBreakdown");
        },
        formatNumberToCurrency(number) {
            return `${this.currencySymbol}${number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        },
        paymentTileSelected() {
            analyticsTrack('Billing Frequency Clicked', {"accountId": this.accountId, "opptyId": this.opptyId, "billingFrequency": this.paymentPlan, "termLength": this.renewalTerm, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
            this.setSelectedPaymentTypeHandler(this.paymentPlan);
        }
    }

}
</script>

<style scoped>
    .sub-header-styling{
        font-size: 20px;
    }
    .header-styling {
        font-size: 33px;
    }
    .tile {
        margin: 1% 0 1% -1px;
        cursor: pointer;
        box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.15), 0 0px 10px 0 rgba(0, 0, 0, 0);
        border-radius: 12px;
    }

    .tile-info {
        position: relative;
        width: 100%;
        padding: 20px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .bottom-spacing {
        margin-bottom: 25px;
    }

    .bold {
        font-weight: bold;
    }

    .monthly-cost {
        font-size: 24px;
        margin-bottom: 20px;
    }
    .list-price-styling {
        font-size: 17px;
    }
    .total-savings{
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height, or 120% */
        color: #17AE63;
    }

    .total-payments{
        background: #F8F8F8;
        border-radius: 50px;
        padding: 9px;
        font-size: 16px;
    }
    .selected {
        outline: 3px solid #0d6ede;
    }

    .save {
        line-height: 100%;
        color: #EB0045;
    }
    .pricing-button {
        border-color: #0d6ede;
        background: transparent;
        font-family: "Nitti Grotesk", sans-serif;
        font-size: 15px;
        font-weight: 700;
        color: black;
        text-transform: uppercase;
        border-radius: 5px;
        display: inline-block;
        border: 1px solid #0d6ede;
        padding: 17px 20px 15px;
        letter-spacing: 1px;
        line-height: 1;
        margin-top: auto;
        text-align: center;
        text-decoration: none;
        text-shadow: none;
        max-width: none !important;
    }

    .pricing-button:hover, .pricing-button:focus {
        color: #ffffff;
        background: #0d6ede;
        text-decoration: none;
    }

    /* only display on tablet and above */
    @media only screen and (min-width: 736px) {
        .col.md-4 {
            max-width: 32%; /* Safari display fix */
        }
        .tile {
            margin-right: 20px;
        }
    }

    @media only screen and (max-width: 736px) {
        .tile {
            margin-bottom: 5%;
        }
    }

    @media only screen and (min-width: 1080px) {
        .col.md-4 {
            max-width: 29%;
        }
    }

    .messaging {
        background: #0D6EDE;
        border-radius: 12px 0px; 
            padding: 10px 20px 10px 20px;
        color: white;
        font-weight: 700;
        font-size: 18px;
    }

    .light-tile-banner {
        background: #F0F6FE;
        color: #0D6EDE;
    }

</style>
